import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BgmAccountInfo,
  BgmAuthUrlResponse,
  BgmSyncStatus,
  DefaultBangumiProvider,
  EnqueueBgmSyncResponse,
  JsonPatch,
  OAuth2Client,
  ServiceClient,
  UpdateServiceClientRequest
} from '../sdk/bangumiProvider';

const DEFAULT_PAGE_SIZE = 20;

@Injectable({
  providedIn: 'root'
})
export class BangumiProviderService {

  constructor(private bgmProvider: DefaultBangumiProvider) {
  }

  listMyOAuth2Client(clientName?: string, pageToken?: string): Observable<{data: OAuth2Client[], first?: string, next?: string}> {
    return this.bgmProvider.listMyOAuth2Client(clientName, DEFAULT_PAGE_SIZE, pageToken);
  }

  createMyOAuth2Client(client: OAuth2Client): Observable<OAuth2Client> {
    return this.bgmProvider.createMyOAuth2Client({client});
  }

  getMyOAuth2Client(clientId: string): Observable<OAuth2Client> {
    return this.bgmProvider.getMyOAuth2Client(clientId);
  }

  patchMyOAuth2Client(clientId: string, op: JsonPatch[]): Observable<OAuth2Client> {
    return this.bgmProvider.patchMyOAuth2Client(clientId, op);
  }

  deleteMyOAuth2Client(clientId: string): Observable<any> {
    return this.bgmProvider.deleteMyOAuth2Client(clientId);
  }

  getServiceClient(clientId: string): Observable<ServiceClient> {
    return this.bgmProvider.getServiceClientById(clientId);
  }

  registerServiceClient(client: ServiceClient, token: string): Observable<ServiceClient> {
    return this.bgmProvider.registerServiceClient(client.clientId, Object.assign({token}, client));
  }

  updateServiceClient(
    clientId: string,
    update: UpdateServiceClientRequest
  ): Observable<ServiceClient> {
    return this.bgmProvider.updateServiceClient(clientId, update);
  }

  clearPendingWebhookEvents(clientId: string): Observable<ServiceClient> {
    return this.bgmProvider.clearPendingWebhookEvents(clientId);
  }

  deleteServiceClient(clientId: string): Observable<any> {
    return this.bgmProvider.deleteServiceClient(clientId);
  }

  getBgmAuthUrl(): Observable<BgmAuthUrlResponse> {
    return this.bgmProvider.getBgmAuthUrl();
  }

  bgmAuthCallback(code: string, state: string): Observable<any> {
    return this.bgmProvider.bgmAuthCallback(code, state, 'body', false, {transferCache: false});
  }

  getBgmAccount(): Observable<BgmAccountInfo> {
    return this.bgmProvider.getBgmAccount('body', false, {transferCache: false});
  }

  deleteBgmAccount(): Observable<any> {
    return this.bgmProvider.deleteBgmAccount();
  }

  updateBgmSyncSettings(autoSync: boolean): Observable<any> {
    return this.bgmProvider.updateBgmSyncSettings({enableAutoSync: autoSync});
  }

  importBgmFavorites(override: boolean, syncBack: boolean): Observable<any> {
    return this.bgmProvider.importFavoritesFromBgm(override, syncBack);
  }

  enqueueBgmSync(favoriteId: string): Observable<EnqueueBgmSyncResponse> {
    return this.bgmProvider.enqueueBgmSync(favoriteId);
  }

  getBgmSyncStatus(favoriteId: string): Observable<BgmSyncStatus> {
    return this.bgmProvider.getBgmSyncStatus(favoriteId, 'body', false, {transferCache: false});
  }
}
